export const MGA_BUTTONS = [
  { text: 'Details', link: 'show' },
  { text: 'Claims', link: 'show/claims' },
  { text: 'Billing', link: 'show/billing' },
  { text: 'Vets', link: 'show/vets' },
  { text: 'Notes', link: 'show/notes' },
  { text: 'Documents', link: 'show/documents' },
  { text: 'Audit Logs', link: 'show/audit-logs' },
];
